import { ValueOf } from "./utility";

export const RecaptchaAction = {
  submit: "submit",
} as const;
export type RecaptchaActionType = ValueOf<typeof RecaptchaAction>;
